export default __webpack_public_path__ + "static/stage-2_1-fabff03cf983e0de39e904d74bac2308.jpg";